import type { IProductBasic } from '@noths/polaris-client-listings-api';
import type { Price, ProductPartner } from '@noths/polaris-dev-ts-types';

import type { TrackingProductData } from 'src/tracking/common/products';

export const transformRecommendationsServiceProductToTrackingProductData = (
  product: Omit<IProductBasic, 'isExpandedSearch'>,
): TrackingProductData => {
  return {
    code: product.code,
    freeDomesticDelivery: product.freeDomesticDelivery,
    isNew: product.isNew,
    onSale: product.onSale,
    salePercentage: product.salePercentage || null,
    partner: product.partner as ProductPartner,
    price: product.price as Price,
    purchasable: product.purchasable,
    title: product.title,
  };
};
